import React, { useState } from 'react';
import { EmailBox, TextBoxLayoutStyle } from '@apply/components';
import { sectionHeaderStyle } from '../constants/styles';

export const EmailBoxPanel: React.FC = () => {
    const [email, set_email] = useState('');

    return (
        <>
            <h6 style={sectionHeaderStyle}>Email Components:</h6>
            <div style={{ marginBottom: '1rem' }}>
                <EmailBox
                    id='emailAddress'
                    name='emailAddress'
                    value={email}
                    onChange={set_email}
                    label='Email Address'
                    required={true}
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <EmailBox
                    id='emailAddress'
                    name='emailAddress'
                    value={email}
                    onChange={set_email}
                    label='Email Address'
                    required={true}
                    showInfoIcon={true}
                    infoText='Email Address Box'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <EmailBox
                    id='emailAddress'
                    name='emailAddress'
                    value={email}
                    onChange={set_email}
                    label='Email Address (Horiz.)'
                    required={true}
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='150px'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <EmailBox
                    id='emailAddress'
                    name='emailAddress'
                    value={email}
                    onChange={set_email}
                    label='Email Address (Horiz.)'
                    required={true}
                    showInfoIcon={true}
                    infoText='Email Address Box'
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='190px'
                />
            </div>
        </>
    );
};
